var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "8 8 24 24",
    enableBackground: "new 8 8 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "18.667,12.713 18.667,20.442 21.333,20.442 21.333,12.713 23.681,14.767 25.438,12.76 20,8.003  14.563,12.76 16.319,14.767  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32,26.664 32,11.552 26.667,11.552 26.667,14.219 29.333,14.219 29.333,23.997 10.667,23.997  10.667,14.219 13.333,14.219 13.333,11.552 8,11.552 8,26.664 18.667,26.664 18.667,29.33 14.667,29.33 14.667,31.997  18.667,31.997 21.333,31.997 25.334,31.997 25.334,29.33 21.333,29.33 21.333,26.664  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublish);
export default __webpack_public_path__ + "static/media/publish.5eaeab2b206441434f835677035d9974.svg";
export { ForwardRef as ReactComponent };